<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="my-3 flex flex-col md:flex-row gap-4 md:items-center">
  <div class="flex items-center gap-3 my-3">
    <app-back-option-section [loading]="loading"></app-back-option-section>
    <h2>Other Booking</h2>
  </div>
  <div class="flex gap-3">
    <!--    With Permissions-->
    <nz-tag *ngIf="havePermissionWithStatus(bookingData?.status, 'OTHER_BOOKING_CHANGE_STATUS', 'COMPLETED', true)"
            [nzColor]="'#3ab200'" class="rounded-full" nz-dropdown nzTrigger="click"
            [nzDropdownMenu]="menu" nzPlacement="bottomCenter">Completed
    </nz-tag>
    <nz-tag *ngIf="havePermissionWithStatus(bookingData?.status, 'OTHER_BOOKING_CHANGE_STATUS', 'CANCELLED', true)"
            class="rounded-full hover:cursor-pointer" [nzColor]="'#F3454C'" nz-dropdown nzTrigger="click"
            [nzDropdownMenu]="menu" nzPlacement="bottomCenter">Cancelled
    </nz-tag>
    <nz-tag *ngIf="havePermissionWithStatus(bookingData?.status, 'OTHER_BOOKING_CHANGE_STATUS', 'RESERVATION', true)"
            [nzColor]="'#FF8C00'" class="rounded-full hover:cursor-pointer" nz-popconfirm nz-dropdown nzTrigger="click"
            [nzDropdownMenu]="menu" nzPlacement="bottomCenter">Reservation
    </nz-tag>
    <nz-tag *ngIf="havePermissionWithStatus(bookingData?.status, 'OTHER_BOOKING_CHANGE_STATUS', 'ON_OTHER_TOUR', true)"
            [nzColor]="'#4655f5'" class="rounded-full hover:cursor-pointer" nz-dropdown nzTrigger="click"
            [nzDropdownMenu]="menu" nzPlacement="bottomCenter">On Other Tour
    </nz-tag>

    <!--    Without Permissions-->
    <nz-tag *ngIf="havePermissionWithStatus(bookingData?.status, 'OTHER_BOOKING_CHANGE_STATUS', 'COMPLETED', false)"
            [nzColor]="'#3ab200'" class="rounded-full">Completed
    </nz-tag>
    <nz-tag *ngIf="havePermissionWithStatus(bookingData?.status, 'OTHER_BOOKING_CHANGE_STATUS', 'CANCELLED', false)"
            class="rounded-full" [nzColor]="'#F3454C'">Cancelled
    </nz-tag>
    <nz-tag *ngIf="havePermissionWithStatus(bookingData?.status, 'OTHER_BOOKING_CHANGE_STATUS', 'RESERVATION', false)"
            [nzColor]="'#FF8C00'" class="rounded-full">Reservation
    </nz-tag>
    <nz-tag *ngIf="havePermissionWithStatus(bookingData?.status, 'OTHER_BOOKING_CHANGE_STATUS', 'ON_OTHER_TOUR', false)"
            [nzColor]="'#4655f5'" class="rounded-full">On Other Tour
    </nz-tag>

    <nz-dropdown-menu #menu="nzDropdownMenu">
      <span *ngIf="bookingData?.status !== 'COMPLETED'">
      <ul nz-menu>
        <li nz-menu-item nz-popconfirm nzPopconfirmTitle="Are you sure you want change the status to Reservation?"
            [nzOkText]="'Yes'" [nzCancelText]="'No'" (nzOnCancel)="handleCancelSelectStatus()"
            *ngIf="bookingData?.status === 'CANCELLED' "
            (nzOnConfirm)="handleOkSelectStatus('RESERVATION')">Reservation
        </li>
        <li nz-menu-item nz-popconfirm nzPopconfirmTitle="Are you sure you want change the status to On Other Tour?"
            *ngIf="bookingData?.status === 'RESERVATION' "
            [nzOkText]="'Yes'" [nzCancelText]="'No'" (nzOnCancel)="handleCancelSelectStatus()"
            (nzOnConfirm)="handleOkSelectStatus('ON_OTHER_TOUR')">On Other Tour
        </li>
        <li nz-menu-item nz-popconfirm nzPopconfirmTitle="Are you sure you want change the status to Completed?"
            *ngIf="bookingData?.status === 'ON_OTHER_TOUR' "
            [nzOkText]="'Yes'" [nzCancelText]="'No'" (nzOnCancel)="handleCancelSelectStatus()"
            (nzOnConfirm)="handleOkSelectStatus('COMPLETED')">Completed
        </li>
        <li nz-menu-item nz-popconfirm nzPopconfirmTitle="Are you sure you want change the status to Cancelled?"
            *ngIf="bookingData?.status === 'ON_OTHER_TOUR' || bookingData?.status === 'RESERVATION'"
            [nzOkText]="'Yes'" [nzCancelText]="'No'" (nzOnCancel)="handleCancelSelectStatus()"
            (nzOnConfirm)="handleOkSelectStatus('CANCELLED')">Cancelled
        </li>
      </ul>
      </span>
    </nz-dropdown-menu>
  </div>
</div>
<nz-tabset [(nzSelectedIndex)]="activeTabIndex">
  <nz-tab nzTitle="Booking Details">

    <div [ngClass]="!loading ? 'block' : 'hidden'">
      <nz-card>
        <div class="flex flex-row flex-wrap items-center md:justify-end gap-2">
          <button nz-button nzType="primary" style="margin-right: 10px"
                  *ngIf="havePermissionWithStatus(this.bookingData?.allocationDetails?.driverCategory, 'REPORT_GENERATE', 'OUTSOURCE_DRIVER', true)"
                  (click)="showReportGenerate();generatePdf()">Invoice - Outsourced Vehicles
          </button>
          <button nz-button nzType="primary"
                  [disabled]="bookingData?.status !== 'ON_OTHER_TOUR'" (click)="openEndDataModal()">Add Another
            Allocation
          </button>
        </div>
      </nz-card>

      <section class="mt-5">
        <nz-card>
          <div class="flex justify-between items-center">
            <h5 class="text-primary">Booking Details</h5>
            <div>
              <button nz-button nzType="primary" (click)="editNavigate()">Edit Details</button>
            </div>
          </div>
          <div class="mt-5 grid md:grid-cols-2 gap-8">
            <div class="sub-section">
              <div class="item-row">
                <p class="subject-name">Reason</p>
                <p class="subject-data">{{ this.bookingData?.reservationDetails?.reason }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Start Date</p>
                <p class="subject-data">{{ bookingData?.reservationDetails?.arrivalDate | date:'yyyy-MM-dd' }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Start Time</p>
                <p class="subject-data">{{ bookingData?.reservationDetails?.arrivalTime | date:'hh:mm a' }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">End Date</p>
                <p class="subject-data">{{ bookingData?.reservationDetails?.departureDate | date:'yyyy-MM-dd' }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">End Time</p>
                <p class="subject-data">{{ bookingData?.reservationDetails?.departureTime | date:'hh:mm a' }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">No. of Days</p>
                <p class="subject-data">{{ bookingData?.reservationDetails?.noOfDays }}</p>
              </div>
            </div>
          </div>
        </nz-card>
      </section>


      <section id="VehicleDetails" class="mt-5" *ngIf="bookingData?.allocationDetails?.driverCategory === 'SR_DRIVER' ">

        <nz-card>
          <div>

            <div class="flex justify-between gap-2 flex-col xl:flex-row">
              <h5 class="text-primary">Vehicle Details</h5>
              <div class="flex flex-wrap lg:flex-nowrap lg:flex-row gap-2 items-center xl:justify-end ">
                <button class="w-full" nz-button (click)="navigate('ACCIDENT')">Add Accident Record</button>
                <button class="w-full" nz-button (click)="navigate('INSPECTION')">Add Inspection Record</button>
                <button class="w-full" nz-button *ngIf="checkCanShowGenerateInventoryReport()"
                        (click)="showGenerateInventoryReportPopup(bookingData?.allocationDetails?.allocatedVehicle?._id)">
                  Generate Inventory Report
                </button>
              </div>
            </div>


            <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">
              <div>
                <div class="sub-section" style="height: 100%">
                  <img *ngIf="bookingData?.allocationDetails?.allocatedVehicle?.generalInformation?.vehicleImg[0]"
                       height="nzAutosize" width="100%"
                       [src]="bookingData?.allocationDetails?.allocatedVehicle?.generalInformation?.vehicleImg[0]"
                       alt="image">
                  <img *ngIf="!bookingData?.allocationDetails?.allocatedVehicle?.generalInformation?.vehicleImg[0]"
                       height="nzAutosize" width="100%" src="assets/img/image-placeholder.png" alt="image">
                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Vehicle Brand</p>
                    <p class="subject-data">{{
                        bookingData?.allocationDetails?.allocatedVehicle?.vehicleDetails?.vehicleBrand ?
                          (bookingData.allocationDetails.allocatedVehicle.vehicleDetails.vehicleBrand) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Model</p>
                    <p class="subject-data">{{
                        bookingData.allocationDetails?.allocatedVehicle?.vehicleDetails?.vehicleModel ?
                          (bookingData.allocationDetails.allocatedVehicle.vehicleDetails.vehicleModel) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Fuel Type</p>
                    <p class="subject-data">{{
                        bookingData.allocationDetails?.allocatedVehicle?.vehicleDetails?.fuelType ?
                          (bookingData.allocationDetails.allocatedVehicle.vehicleDetails.fuelType) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Transmission</p>
                    <p class="subject-data">{{
                        bookingData.allocationDetails?.allocatedVehicle?.vehicleDetails?.transmission ?
                          (bookingData.allocationDetails.allocatedVehicle.vehicleDetails.transmission) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Registration Number</p>
                    <p class="subject-data">{{
                        bookingData.allocationDetails?.allocatedVehicle?.vehicleDetails?.registrationNumber ?
                          (bookingData.allocationDetails.allocatedVehicle.vehicleDetails.registrationNumber) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">No. of Seats</p>
                    <p class="subject-data">{{
                        bookingData.allocationDetails?.allocatedVehicle?.vehicleDetails?.seatsNumber
                          ? (bookingData.allocationDetails.allocatedVehicle.vehicleDetails.seatsNumber) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Color</p>
                    <p class="subject-data">{{
                        bookingData.allocationDetails?.allocatedVehicle?.vehicleDetails?.color ?
                          (bookingData.allocationDetails.allocatedVehicle.vehicleDetails.color) : '-'
                      }}</p>
                  </div>

                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Start Mileage</p>
                    <p class="subject-data">{{
                        bookingData.allocationDetails.startMileage ?
                          (bookingData.allocationDetails.startMileage + ' KM') : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Start Fuel</p>
                    <p class="subject-data">{{
                        bookingData.allocationDetails.startFuel ?
                          (bookingData.allocationDetails.startFuel + ' %') : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">End Mileage</p>
                    <p class="subject-data">{{
                        bookingData.allocationDetails.endMileage ?
                          (bookingData.allocationDetails.endMileage + ' KM') : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">End Fuel</p>
                    <p class="subject-data">{{
                        bookingData.allocationDetails.endFuel ?
                          (bookingData.allocationDetails.endFuel + ' %') : '-'
                      }}</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </nz-card>
      </section>

      <section id="driverDetails" class="mt-5">

        <nz-card>
          <div>
            <div class="flex justify-between gap-2 flex-col md:flex-row">
              <h5 class="text-primary">Driver Details</h5>

            </div>
            <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Driver Category</p>
                    <p *ngIf="bookingData?.allocationDetails?.allocatedDriver?.driverSegment === 'SR_DRIVER'"
                       class="subject-data">SR Driver
                    </p>
                    <p *ngIf="bookingData?.allocationDetails?.allocatedDriver?.driverSegment !== 'SR_DRIVER'"
                       class="subject-data">
                      Outsourced Driver</p>
                  </div>
                  <div class="item-row"
                       *ngIf="bookingData?.allocationDetails?.allocatedDriver?.driverSegment !== 'SR_DRIVER'">
                    <p class="subject-name">Supplier</p>
                    <p style="cursor: pointer; color:#f06a21"
                       (click)="showSupplierModal(bookingData?.allocationDetails?.allocatedDriver?.supplier)"
                       class="subject-data">{{
                        bookingData?.allocationDetails?.allocatedDriver ?
                          bookingData?.allocationDetails?.allocatedDriver?.supplier?.supplierDetails?.name : '-'
                      }}</p>
                  </div>
                  <div class="item-row"
                       *ngIf="bookingData?.allocationDetails?.allocatedDriver?.driverSegment !== 'SR_DRIVER'">
                    <p class="subject-name">Outsourced Rate</p>
                    <p class="subject-data">{{
                        bookingData?.allocationDetails?.outsourcedRate ?
                          bookingData?.allocationDetails?.outsourcedRate : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Can Drive</p>
                    <div *ngFor="let item of bookingData?.allocationDetails.allocatedDriver?.canDrive">
                      <p class="subject-data">{{ item.label ? (item.label + ' ') : '-' }}</p>
                    </div>
                  </div>

                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Driver Name</p>
                    <p (click)="showDriverModal(bookingData?.allocationDetails?.allocatedDriver)"
                       style="cursor: pointer; color:#f06a21"
                       class="subject-data">{{
                        bookingData?.allocationDetails?.allocatedDriver?.fullName ?
                          (bookingData?.allocationDetails?.allocatedDriver?.fullName) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">NIC</p>
                    <p class="subject-data">{{
                        bookingData?.allocationDetails?.allocatedDriver?.nicNo ?
                          (bookingData?.allocationDetails?.allocatedDriver?.nicNo) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Mobile Number</p>
                    <p class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no" href="tel:{{
                        bookingData?.allocationDetails?.allocatedDriver?.mobileNumber ?
                          (bookingData?.allocationDetails?.allocatedDriver?.mobileNumber) : '-'
                      }}">{{
                        bookingData?.allocationDetails?.allocatedDriver?.mobileNumber ?
                          (bookingData?.allocationDetails?.allocatedDriver?.mobileNumber) : '-'
                      }}</a></p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Email</p>
                    <p class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no" href="mailto:{{
                        bookingData?.allocationDetails?.allocatedDriver?.email ?
                          (bookingData?.allocationDetails?.allocatedDriver?.email) : '-'
                      }}">{{
                        bookingData?.allocationDetails?.allocatedDriver?.email ?
                          (bookingData?.allocationDetails?.allocatedDriver?.email) : '-'
                      }}</a></p>
                  </div>


                </div>
              </div>

              <div *ngIf="this.bookingData?.allocationDetails?.driverCategory === 'OUTSOURCE_DRIVER'">
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Vehicle Model</p>
                    <p class="subject-data">{{ departureVeh.model }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Vehicle Registration Number</p>
                    <p class="subject-data">{{ departureVeh.reg }}</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </nz-card>
      </section>


      <div *ngFor="let item of this.bookingData?.allocationList.slice().reverse(); let i = index">
        <section id="VehicleAllocationDepDetails" class="mt-5"
                 *ngIf="item.vehicle ">

          <nz-card>
            <div>
              <div class="flex justify-between gap-2 flex-col lg:flex-row">
                <h5 class="text-primary">Vehicle Details (Previous - No: {{ i + 1 }} )</h5>
                <div class="flex flex-wrap md:flex-nowrap md:flex-row gap-2 items-center lg:justify-end ">
                  <!--                  <button nz-button (click)="navigate('INSPECTION')">Add Inspection Record</button>-->
                  <!--                  <button nz-button (click)="navigate('ACCIDENT')">Add Accident Record</button>-->
                </div>
              </div>
              <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">

                <div>
                  <div class="sub-section" style="height: 100%">
                    <img *ngIf="item.vehicle?.generalInformation?.vehicleImg[0]" height="nzAutosize" width="100%"
                         [src]="item.vehicle?.generalInformation?.vehicleImg[0]" alt="image">
                    <img *ngIf="!item.vehicle?.generalInformation?.vehicleImg[0]" height="nzAutosize" width="100%"
                         src="assets/img/image-placeholder.png" alt="image">
                  </div>
                </div>

                <div>
                  <div class="sub-section" style="height: 100%">
                    <div class="item-row">
                      <p class="subject-name">Vehicle Brand</p>
                      <p class="subject-data">{{
                          item.vehicle?.vehicleDetails?.vehicleBrand ?
                            (item.vehicle?.vehicleDetails.vehicleBrand) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Model</p>
                      <p class="subject-data">{{
                          item?.vehicle.vehicleDetails?.vehicleModel ?
                            (item.vehicle?.vehicleDetails.vehicleModel) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Fuel Type</p>
                      <p class="subject-data">{{
                          item.vehicle?.vehicleDetails?.fuelType ?
                            (item.vehicle?.vehicleDetails.fuelType) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Transmission</p>
                      <p class="subject-data">{{
                          item.vehicle?.vehicleDetails?.transmission ?
                            (item.vehicle?.vehicleDetails.transmission) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Registration Number</p>
                      <p class="subject-data">{{
                          item.vehicle?.vehicleDetails?.registrationNumber ?
                            (item.vehicle?.vehicleDetails.registrationNumber) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">No. of Seats</p>
                      <p class="subject-data">{{
                          item.vehicle?.vehicleDetails?.seatsNumber ?
                            (item.vehicle?.vehicleDetails.seatsNumber) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Color</p>
                      <p class="subject-data">{{
                          item.vehicle?.vehicleDetails?.color ?
                            (item.vehicle?.vehicleDetails.color) : '-'
                        }}</p>
                    </div>

                  </div>
                </div>

                <div>
                  <div class="sub-section" style="height: 100%">
                    <div class="item-row">
                      <p class="subject-name">Start Mileage</p>
                      <p class="subject-data">{{ item.startMileage ? (item.startMileage + ' KM') : '-' }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Start Fuel</p>
                      <p class="subject-data">{{ item.startFuel ? (item.startFuel + ' %') : '-' }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">End Mileage</p>
                      <p class="subject-data">{{ item.endMileage ? (item.endMileage + ' KM') : '-' }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">End Fuel</p>
                      <p class="subject-data">{{ item.endFuel ? (item.endFuel + ' %') : '-' }}</p>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </nz-card>
        </section>


        <section id="driverAllocationDepDetails" class="mt-5">

          <nz-card>
            <div>
              <div class="flex justify-between gap-2 flex-col md:flex-row">
                <h5 class="text-primary">Driver Details (Previous - No: {{ i + 1 }})</h5>

              </div>
              <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">

                <div>
                  <div class="sub-section" style="height: 100%">
                    <div class="item-row">
                      <p class="subject-name">Driver Category</p>

                      <p *ngIf="item.driver?.driverSegment === 'SR_DRIVER'" class="subject-data">SR Driver</p>
                      <p *ngIf="item.driver?.driverSegment !== 'SR_DRIVER'" class="subject-data">Outsourced Driver</p>
                    </div>
                    <div class="item-row" *ngIf="item.driver?.driverSegment !== 'SR_DRIVER'">
                      <p class="subject-name">Supplier</p>
                      <p style="cursor: pointer; color:#f06a21" (click)="showSupplierModal(item.driver?.supplier)"
                         class="subject-data">{{ item.supplier ? item.supplier : '-' }}</p>
                    </div>
                    <div class="item-row" *ngIf="item.driver?.driverSegment === 'OUTSOURCE_DRIVER'">
                      <p class="subject-name">Outsourced Rate</p>
                      <p class="subject-data">{{ item.outRate ? item.outRate : '-' }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Can Drive</p>
                      <div *ngFor="let item of item.driver?.canDrive">
                        <p class="subject-data">{{ item.label ? (item.label + ',') : '-' }}</p>
                      </div>
                    </div>

                  </div>
                </div>

                <div>
                  <div class="sub-section" style="height: 100%">
                    <div class="item-row">
                      <p class="subject-name">Driver Name</p>
                      <p (click)="showDriverModal(item.driver)" style="cursor: pointer; color:#f06a21"
                         class="subject-data">{{
                          item.driver?.fullName ? (item.driver?.fullName) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">NIC</p>
                      <p class="subject-data">{{ item.driver?.nicNo ? (item.driver?.nicNo) : '-' }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Mobile Number</p>
                      <p class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no"
                                                                         href="tel:{{ item.driver?.mobileNumber ? (item.driver?.mobileNumber) : '-' }}">{{ item.driver?.mobileNumber ? (item.driver?.mobileNumber) : '-' }}</a>
                      </p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Email</p>
                      <p class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no"
                                                                         href="mailto:{{ item.driver?.email ? (item.driver?.email) : '-' }}">{{ item.driver?.email ? (item.driver?.email) : '-' }}</a>
                      </p>
                    </div>


                  </div>
                </div>

                <div *ngIf="!item.vehicle">
                  <div class="sub-section" style="height: 100%">
                    <div class="item-row">
                      <p class="subject-name">Vehicle Model</p>
                      <p class="subject-data">{{ item.driverVehModel }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Vehicle Registration Number</p>
                      <p class="subject-data">{{ item.driverVehReg }}</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </nz-card>
        </section>
      </div>

    </div>
    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-single-view-skeleton-template [typeName]="'single-view'"></app-single-view-skeleton-template>
    </div>

  </nz-tab>
  <nz-tab nzTitle="Other Details">
    <section>
      <nz-card [ngClass]="!loading ? 'block' : 'hidden'">
        <div class="mt-5 grid xl:grid-cols-2 gap-2">
          <div>
            <nz-divider></nz-divider>
            <div class="flex mb-5">
              <p class="font-semibold mr-5">Remarks</p>
            </div>
            <div>
              <div class="grid grid-cols-3">
                <p class="text-sm mx-2 font-bold">Date</p>
                <p class="text-sm mx-2 font-bold">Action</p>
                <p class="text-sm mx-2 font-bold">Remark</p>
                <!--                <p>{{remark?.createdBy?.firstname + " " + remark?.createdBy?.lastname}}</p>-->
              </div>
            </div>
            <div *ngFor="let remark of bookingData?.remarks">
              <div class="grid grid-cols-3 mt-2 content-center">
                <p class="text-sm mx-2">{{ remark?.createdAt | date: 'dd-MM-y' }}</p>
                <p class="text-sm mx-2">{{ remark?.action }}</p>
                <p class="text-sm mx-2">{{ remark?.remark }}</p>
                <!--                <p>{{remark?.createdBy?.firstname + " " + remark?.createdBy?.lastname}}</p>-->
              </div>
              <nz-divider></nz-divider>
            </div>
            <div class="grid grid-cols-3 mt-2 content-center">
              <p class="text-sm mx-2" *ngIf="!bookingData?.remarks === null || bookingData?.remarks.length < 1">
              </p>
              <p class="text-sm mx-2 mt-4" *ngIf="!bookingData?.remarks === null || bookingData?.remarks.length < 1">No
                Data</p>
              <p class="text-sm mx-2" *ngIf="!bookingData?.remarks === null || bookingData?.remarks.length < 1">
              </p>
            </div>
          </div>
        </div>
      </nz-card>
      <div [ngClass]="loading ? 'block' : 'hidden'">
        <app-single-view-skeleton-template [typeName]="'note-view'"></app-single-view-skeleton-template>
      </div>
    </section>
  </nz-tab>
</nz-tabset>


<nz-modal [(nzVisible)]="isVisibleFuelAndMileageUpdate" [nzTitle]="modalTitle" [nzContent]="modalContent"
          [nzFooter]="modalFooter" (nzOnCancel)="handleCancelUpdateFuelAndMileage()">
  <ng-template #modalTitle>{{
      changingStatus === 'CANCELLED' ? 'Reason for Cancellation' : 'Current Fuel and Mileage
        Update'
    }}
  </ng-template>

  <ng-template #modalContent>
    <div *ngIf="changingStatus === 'ON_OTHER_TOUR' || changingStatus === 'COMPLETED'" class="flex flex-col gap-4">
      <p class="font-bold">{{ changingStatus === 'ON_OTHER_TOUR' ? 'Start' : 'End' }} Mileage :</p>
      <nz-input-group nzAddOnAfter="Km">
        <input nz-input type="number" [min]="0" [step]="1" [(ngModel)]="mileage" placeholder="Enter Mileage"/>
      </nz-input-group>
<!--      <nz-input-number class="w-full" [(ngModel)]="mileage" nzPlaceHolder="Enter Mileage" [nzMin]="0" [nzStep]="1"-->
<!--                       [nzFormatter]="formatterDistance" [nzParser]="parserDistance"></nz-input-number>-->

      <p class="font-bold">{{ changingStatus === 'ON_OTHER_TOUR' ? 'Start' : 'End' }} Fuel Level :</p>
      <nz-input-group nzAddOnAfter="%">
        <input nz-input type="number" [min]="0" [max]="100" [step]="1" [(ngModel)]="fuelLevel" placeholder="Enter Fuel Level"/>
      </nz-input-group>
<!--      <nz-input-number class="w-full" [(ngModel)]="fuelLevel" nzPlaceHolder="Enter Fuel Level" [nzMin]="0" [nzMax]="100"-->
<!--                       [nzStep]="1" [nzFormatter]="formatterPercentFuel"-->
<!--                       [nzParser]="parserPercentFuel"></nz-input-number>-->
    </div>

    <div *ngIf="changingStatus === 'CANCELLED'" class="flex flex-col">
      <p class="font-bold">Reason to Cancel :</p>
      <nz-select class="w-full" [(ngModel)]="cancelReason" nzPlaceHolder="Select Preference" nzShowSearch nzAllowClear
                 [nzDropdownRender]="renderTemplate">
        <nz-option *ngFor="let item of cancelReasonOptions" [nzLabel]="item" [nzValue]="item"></nz-option>
      </nz-select>
      <ng-template #renderTemplate>
        <nz-divider></nz-divider>
        <div class="flex flex-col justify-center mx-3">
          <input type="text" nz-input #inputElement/>
          <a class="text-center m-1" (click)="addItem(inputElement)">
            <span nz-icon nzType="plus"></span>
            Add item
          </a>
        </div>
      </ng-template>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button (click)="handleCancelUpdateFuelAndMileage()" nzType="default">Cancel</button>
    <button *ngIf="!(changingStatus === 'CANCELLED')" nz-button nzType="primary"
            [disabled]="(fuelLevel === 0 || undefined) || (mileage === 0 || undefined)" nz-popconfirm
            nzPopconfirmTitle="Are you sure you want to save this information and change the status?" [nzOkText]="'Yes'"
            [nzCancelText]="'No'" (nzOnCancel)="handleCancelUpdateFuelAndMileage()"
            (nzOnConfirm)="handleOkUpdateFuelAndMileage()" [nzLoading]="isLoading">Save
    </button>
    <button *ngIf="changingStatus === 'CANCELLED'" nz-button nzType="primary" [disabled]="(cancelReason === null)"
            nz-popconfirm nzPopconfirmTitle="Are you sure you want to save this information and change the status?"
            [nzOkText]="'Yes'" [nzCancelText]="'No'" (nzOnCancel)="handleCancelUpdateFuelAndMileage()"
            (nzOnConfirm)="handleOkCancelledStatus()" [nzLoading]="isLoading">Save
    </button>
  </ng-template>
</nz-modal>


<nz-modal [(nzVisible)]="isVisibleAddAllocation" [nzTitle]="modal3Title" [nzContent]="modal3Content"
          [nzFooter]="modal3Footer" (nzOnCancel)="handleCancelAllocation()">
  <ng-template #modal3Title>Add Another Allocation</ng-template>

  <ng-template #modal3Content>

    <form nz-form [formGroup]="allocationForm" [nzLayout]="'vertical'">
      <div class=" grid xl:grid-cols-2 gap-2">


        <nz-form-item class="grid grid-flow-row content-start">
          <nz-form-label nzFor="vehicleCategory" nzRequired>Vehicle Category</nz-form-label>
          <nz-form-control>
            <nz-select class="w-full" formControlName="vehicleCategory" (ngModelChange)="getVehicles($event)"
                       nzPlaceHolder="Select Preference">
              <nz-option *ngFor="let category of vehicleCat" [nzValue]="category._id"
                         [nzLabel]="category.name"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item class="grid grid-flow-row content-start">
          <nz-form-label nzFor="allocatedVehicle" nzRequired>Allocated Vehicle</nz-form-label>
          <nz-form-control>
            <nz-select class="w-full" formControlName="allocatedVehicle" nzPlaceHolder="Select Preference">
              <nz-option *ngFor="let vehicle of this.availableVehicles" [nzValue]="vehicle._id"
                         [nzLabel]="vehicle.vehicleName"></nz-option>
            </nz-select>
          </nz-form-control>
          <p class="my-2 text-primary text-sm" *ngIf="fleetsFetching">Loading...</p>
        </nz-form-item>

        <nz-form-item class="grid grid-flow-row content-start">
          <nz-form-label nzFor="startFuel" nzRequired>Start Fuel</nz-form-label>
          <nz-form-control>
            <nz-input-group nzAddOnAfter="Km">
              <input nz-input type="number" [min]="0" [max]="100" [step]="1" formControlName="startFuel" placeholder="Enter Number"/>
            </nz-input-group>
<!--            <nz-input-number nz-input type="number" class="w-full" formControlName="startFuel"-->
<!--                             placeholder="Enter Number" [nzMin]="0" [nzMax]="100"-->
<!--                             [nzStep]="1" [nzFormatter]="formatterPercentFuel"-->
<!--                             [nzParser]="parserPercentFuel"/>-->
          </nz-form-control>
        </nz-form-item>


        <nz-form-item class="grid grid-flow-row content-start">
          <nz-form-label nzFor="startMileage" nzRequired>Start Mileage ( KM )</nz-form-label>
          <nz-form-control>
            <nz-input-group nzAddOnAfter="Km">
              <input nz-input type="number" [min]="0" [step]="1" formControlName="startMileage" placeholder="Enter Number"/>
            </nz-input-group>
<!--            <nz-input-number nz-input type="number" class="w-full" formControlName="startMileage"-->
<!--                             placeholder="Enter Number" [nzMin]="0" [nzStep]="1"-->
<!--                             [nzFormatter]="formatterDistance" [nzParser]="parserDistance"/>-->
          </nz-form-control>
        </nz-form-item>

        <span nz-checkbox formControlName="driverAllocationCheck" class="mb-4">Driver Allocation</span>

        <span></span>

        <nz-form-item class="grid grid-flow-row content-start"
                      *ngIf="allocationForm.get('driverAllocationCheck').value">
          <nz-form-label nzFor="driverCategory" nzRequired>Driver Category</nz-form-label>
          <nz-form-control>
            <nz-select class="w-full" formControlName="driverCategory" (ngModelChange)="getDriverOptions($event)"
                       nzPlaceHolder="Select Preference">
              <nz-option nzValue="SR_DRIVER" nzLabel="SR Drivers"></nz-option>
              <nz-option nzValue="OUTSOURCE_DRIVER" nzLabel="Outsourced Drivers"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <span></span>

        <nz-form-item class="grid grid-flow-row content-start"
                      *ngIf="allocationForm.get('driverAllocationCheck').value">
          <nz-form-label nzFor="allocatedDriver" nzRequired>Allocated Driver</nz-form-label>
          <nz-form-control>
            <nz-select class="w-full" formControlName="allocatedDriver"
                       (ngModelChange)="getSupplierVehicles($event);getDriver($event)"
                       nzPlaceHolder="Select Preference">
              <nz-option *ngFor="let op of availableDriver" nzValue="{{op._id}}" nzLabel="{{op.fullName}}"></nz-option>
            </nz-select>
          </nz-form-control>
          <p class="my-2 text-primary text-sm" *ngIf="driversFetching">Loading...</p>
        </nz-form-item>

        <nz-form-item class="grid grid-flow-row content-start"
                      *ngIf="allocationForm.get('driverCategory').value !== null">
          <nz-form-control>
            <button (click)="showAddDriverPopup()" (keydown.enter)="$event.preventDefault()"
                    class="outline-button custom-btn_add" style="margin-top: 2.15rem; width: 150px" nz-button
                    nzType="default">Add New
              Driver
            </button>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item class="grid grid-flow-row content-start"
                      *ngIf="allocationForm.get('driverCategory').value === 'OUTSOURCE_DRIVER' && allocationForm.get('driverAllocationCheck').value">
          <nz-form-label nzFor="allocatedDriverVehicle" nzRequired>Allocated Vehicle</nz-form-label>
          <nz-form-control>
            <nz-select class="w-full" formControlName="allocatedDriverVehicle" nzPlaceHolder="Select Preference">
              <nz-option *ngFor="let op of supplierVehicleOptions" nzValue="{{op?._id}}"
                         nzLabel="{{op?.registerNumber}} | {{op?.vehicleModel}}"></nz-option>
            </nz-select>
          </nz-form-control>
          <p class="my-2 text-primary text-sm" *ngIf="supplierVehiclesFetching">Loading...</p>
        </nz-form-item>

        <nz-form-item class="grid grid-flow-row content-start"
                      *ngIf="allocationForm.get('driverCategory').value === 'OUTSOURCE_DRIVER'">
          <nz-form-control>
            <button (click)="showAddVehiclePopup()"
                    [disabled]="this.allocationForm.get('allocatedDriver').value === null"
                    (keydown.enter)="$event.preventDefault()" class="outline-button"
                    style="margin-top: 2.15rem; width: 150px" nz-button
                    nzType="default">Add New
              Vehicle
            </button>
          </nz-form-control>
        </nz-form-item>


        <nz-form-item class="grid grid-flow-row content-start"
                      *ngIf="allocationForm.get('driverCategory').value === 'OUTSOURCE_DRIVER' && allocationForm.get('driverAllocationCheck').value">
          <nz-form-label nzFor="outsourcedRate" nzRequired>Outsourced Rate</nz-form-label>
          <nz-form-control>
            <nz-input-number-group [nzAddOnAfter]="addOnAfterTemplate">
              <nz-input-number formControlName="outsourcedRate" [nzPlaceHolder]="'Enter rate'" [nzStep]="1"
                               [nzMin]="0"></nz-input-number>
            </nz-input-number-group>
            <ng-template #addOnAfterTemplate>
              <div style="display: flex; align-items: center;">
                <span style=""></span>
                <nz-select formControlName="outsourcedRateCurrency" style="width: 80px;">
                  <nz-option *ngFor="let op of currencyOptions" [nzValue]="op._id"
                             [nzLabel]="op.currencyCode"></nz-option>
                </nz-select>
              </div>
            </ng-template>
          </nz-form-control>
        </nz-form-item>


      </div>
    </form>
  </ng-template>

  <ng-template #modal3Footer>
    <button nz-button nzType="default" (click)="handleCancelAllocation()">Cancel</button>
    <button nz-button nzType="primary" (click)="saveAllocation()" [disabled]="this.allocationForm.invalid">Save</button>
  </ng-template>
</nz-modal>


<nz-modal [(nzVisible)]="isVisibleEndData" [nzTitle]="modal2Title" [nzContent]="modal2Content" [nzFooter]="modal2Footer"
          (nzOnCancel)="handleCancelEndData()">
  <ng-template #modal2Title></ng-template>

  <ng-template #modal2Content>

    <div class="flex flex-col gap-4">
      <p class="font-bold">End Mileage :</p>
      <nz-input-group nzAddOnAfter="Km">
        <input nz-input type="number" [min]="0" [step]="1" [(ngModel)]="endMileage" placeholder="Enter Mileage"/>
      </nz-input-group>

      <p class="font-bold">End Fuel Level :</p>
      <nz-input-group nzAddOnAfter="%">
        <input nz-input type="number" [min]="0" [max]="100" [step]="1" [(ngModel)]="endFuel" placeholder="Enter end Fuel"/>
      </nz-input-group>
    </div>

  </ng-template>

  <ng-template #modal2Footer>
    <button nz-button nzType="default" (click)="handleCancelEndData()">Cancel</button>
    <button nz-button nzType="primary" (click)="saveEndData()">Save</button>
  </ng-template>
</nz-modal>

<nz-modal [(nzVisible)]="isShowReport" [nzTitle]="modalTitle12" [nzContent]="modalContent12" [nzFooter]="modalFooter12"
          (nzOnCancel)="handleCancel()" nzClosable="false">
  <ng-template #modalTitle12>
    <div class="flex justify-between items-center my-4">
      <h4>Invoice for Outsource Vehicle</h4>
      <button *appHasAnyPrivilege="''" nz-button nzType="primary" [disabled]="!this.pdfLoader"
              (click)="viewPdf()">Preview
      </button>
    </div>
  </ng-template>

  <ng-template #modalContent12>
    <div class="my-4">
      <p style="font-weight: normal; color:#F06A21" *ngIf="!this.pdfLoader">Report Generating ....</p>
      <p style="font-weight: normal" *ngIf="this.pdfLoader">Report Generated Successfully!</p>
    </div>
  </ng-template>

  <ng-template #modalFooter12>
    <div class="flex justify-between items-center my-4">
      <button nz-button nzType="default" style="color: white; background: #9A9A9A;border-color: #9A9A9A"
              (click)="handleCancel()">
        Cancel
      </button>
      <div class="flex gap-2">
        <button *appHasAnyPrivilege="''" nz-button nzType="default" [disabled]="!this.pdfLoader"
                class="outline-button" (click)="downloadPdf()">
          Download
        </button>
        <button nz-button nzType="default" [disabled]="!this.pdfLoader" class="outline-button" (click)="emailPdf()">
          Send
        </button>
        <button nz-button nzType="default" [disabled]="!this.pdfLoader" class="outline-button" (click)="printReport()">
          Print
        </button>
      </div>
    </div>
  </ng-template>
</nz-modal>

<app-generate-inventory-report-popup *ngIf="isVisibleGenerateInventoryReport"
                                     (handleGenerateInventoryReportOnChange)="onGetGenerateInventoryReportChange($event)"
                                     [isVisibleGenerateInventoryReport]="isVisibleGenerateInventoryReport"
                                     [inventoryId]="relevantInventoryId"
                                     [bookingData]="inventoryBookingData"></app-generate-inventory-report-popup>

<app-single-view-driver-popup [isVisible]="visibleDriverModal" (viewDriverOnchange)="DriverModal($event)"
                              [driverData]="this.selectedDriver"></app-single-view-driver-popup>
<app-single-view-supplier-popup *ngIf="visibleSupplierModal" [isVisible]="visibleSupplierModal"
                                (viewSupplierOnchange)="SupplierModal($event)"
                                [supplierId]="this.selectedSupplier?._id"></app-single-view-supplier-popup>
<app-add-driver-popup [isVisible]="visibleAddDriverPopup"
                      (addEditDriverOnChange)="onGetAddDriverChange($event)"></app-add-driver-popup>
<app-vehicle-details-form [isVisible]="visibleAddVehiclePopup" [supplier]="selectedSupplierId"
                          (addVehicleOnChange)="onGetAddVehicleChange($event)"></app-vehicle-details-form>
